import type { TownsquareGoal } from '../../types';

export const isTownsquareGoal = (entity: any): entity is TownsquareGoal =>
	entity.__typename === 'TownsquareGoal';

export const getTownsquareGoalLink = (goal: TownsquareGoal): string | null => goal?.url ?? null;
